var render = function (_h,_vm) {var _c=_vm._c;return _c('hr',{class:[_vm.data.class, _vm.data.staticClass, 'sf-divider'],style:([_vm.data.style, _vm.data.staticStyle])},[])}
var staticRenderFns = []

export { render, staticRenderFns }